import React from "react";
var __jsx = React.createElement;
function WarningIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "96",
    height: "88",
    viewBox: "0 0 96 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    opacity: "0.4",
    d: "M96 35.8405V51.4883C96 77.5681 86.4 88 62.4 88H33.6C9.6 88 0 77.5681 0 51.4883V35.8405C0 13.9436 6.768 3.09858 23.136 0.154929H24L72 0C88.992 2.68544 96 13.5821 96 35.8405Z",
    fill: "#FAE1B2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "exclamation-mark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M20 43.5C20 27.7608 32.7608 15 48.5 15C64.2408 15 77 27.7608 77 43.5C77 59.2428 64.241 72 48.5 72C32.7608 72 20 59.241 20 43.5ZM25.3438 43.5C25.3438 56.2893 35.7107 66.6562 48.5 66.6562C61.2893 66.6562 71.6562 56.2893 71.6562 43.5C71.6562 30.7107 61.2893 20.3438 48.5 20.3438C35.7107 20.3438 25.3438 30.7107 25.3438 43.5ZM48.5018 27.499C46.4605 27.499 44.9161 28.5642 44.9161 30.2849V46.0667C44.9161 47.7891 46.4603 48.8508 48.5018 48.8508C50.4932 48.8508 52.0875 47.7447 52.0875 46.0667V30.2849C52.0873 28.6051 50.4932 27.499 48.5018 27.499ZM44.9445 55.9651C44.9445 54.0024 46.5406 52.4063 48.5018 52.4063C50.4629 52.4063 52.057 54.0022 52.0572 55.9651C52.0572 57.9245 50.4629 59.5205 48.5018 59.5205C46.5406 59.5205 44.9445 57.9245 44.9445 55.9651Z",
    fill: "#FCC094"
  }))));
}
export default WarningIcon;